import { modals } from "@mantine/modals";
import { MessageResponse } from "../../model/MessageResponse";
import { IconCheck, IconX } from "@tabler/icons-react";
import { Box, Button, Group, Text } from "@mantine/core";
import { repositorySign } from "../../_base/_const/_constVar";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { notifications } from "@mantine/notifications";

const PartnersDeleteView = ({
  ids,
  onSearch,
  onClose,
}: PartnersDeleteViewProps) => {
  const handleDeleteVendor = async () => {
    let url = "https://apis-pos-dev.hacom.vn/api-sign/api/v1/TblVendor/delete";
    const response = await repositorySign.post<MessageResponse<boolean>>(
      url,
      ids
    );

    if (response?.success) {
      NotificationExtension.Success("Xóa thành công!!");
    } else NotificationExtension.Fails("Xóa thất bại !");
    onClose((prev: any) => !prev);
    modals.closeAll();

    onSearch();
  };

  return (
    <Box size={"auto"}>
      <Text size="20px" mt={5}>
        Bạn có chắc chắn muốn xóa các đối tác tính này ?
      </Text>
      <Group justify="center" mt="lg">
        <Button
          type="button"
          color="gray"
          onClick={() => modals.closeAll()}
          leftSection={<IconX size={18} />}
        >
          Hủy
        </Button>
        <Button
          type="button"
          color="red"
          onClick={handleDeleteVendor}
          leftSection={<IconCheck size={18} />}
        >
          Xóa
        </Button>
      </Group>
    </Box>
  );
};
type PartnersDeleteViewProps = {
  ids: (number | string)[];
  onSearch: () => void;
  onClose: any;
};
export default PartnersDeleteView;
